import React from "react";
import Tab from 'react-bootstrap/Tab'
import Tabs from 'react-bootstrap/Tabs'
import Nav from 'react-bootstrap/Nav'

import EmployerDeclarations from '../employer-declarations'
import DeclarationReportModal from '../declaration-report-modal'
import DetailedCompanyInfo from "../detailed-company-info";
import EmployeeOverview from "../employee-overview"
import EmployerAccessRequest from "../employer-access-request";
import Skilagreinar from '../skilagreinar';
import { fetchCompanyDetails } from '../../api/company-details/actions'

class CompanyPagesTab extends React.Component {
    constructor(props) {
        super(props)
    }

    onNavLinkClick(e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.tabs .nav-item').removeClass('no-border');
        tab.addClass('no-border');
    }

    render() {
        let id = this.props.company.company_id;
        if(this.props.companyDetails.data) {
            return (
                <>
                <Tab.Container defaultActiveKey="employerDeclarations" id="uncontrolled-tab-example">
                    <div className="tabs-container">
                        <Nav variant="tabs" className="tabs">
                            <Nav.Item className="check">
                                <Nav.Link eventKey="employerDeclarations" title="Employer Declarations" onClick={this.onNavLinkClick.bind(this)}>
                                    {this.props.company.name}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="check">
                                <Nav.Link eventKey="skilagreinar" title="Skilagreinar" onClick={this.onNavLinkClick.bind(this)}>
                                    Skilagreinar
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="check">
                                <Nav.Link eventKey="employees" title="Employees" onClick={this.onNavLinkClick.bind(this)}>
                                    Skráðir notendur
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="check">
                                <Nav.Link eventKey="employer-access" title="Sækja um aðgang" onClick={this.onNavLinkClick.bind(this)}>
                                    Sækja um aðgang
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <Tab.Content className="w-100">
                        <Tab.Pane eventKey="employerDeclarations">
                            <DetailedCompanyInfo company={this.props.company} companyDetails={this.props.companyDetails} dispatch={this.props.dispatch}/>
                            
                            
                            <div className="statement-wrapper">
                                <div>
                                    <i>Yfirlit skilagreina</i>
                                    <p>Hér má nálgast yfirlit yfir skilagreinar sem sendar hafa verið fyrir þitt fyrirtæki</p>
                                </div>
                                <div className="employer-statement">
                                    <div className="overview">
                                        <button className="btn btn-warning"  data-toggle="modal" data-target={'#DeclarationReportModal-' + id}>Sækja yfirlit</button>
                                    </div>
                                    <DeclarationReportModal modalId={"DeclarationReportModal-" + id} declarationType="employer_declaration" id={id} dispatch={this.props.dispatch} />
                                </div>
                            </div>
                            {/* <EmployerDeclarations dispatch={this.props.dispatch} declarations={this.props.declarations} /> */}
                        </Tab.Pane>
                        <Tab.Pane eventKey="skilagreinar">
                            <Skilagreinar dispatch={this.props.dispatch} company={this.props.company} companyDetails={this.props.companyDetails}/>
                        </Tab.Pane>                        
                        <Tab.Pane eventKey="employees">
                            <EmployeeOverview companyDetails={this.props.companyDetails} company={this.props.company} dispatch={this.props.dispatch} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="employer-access">
                            <EmployerAccessRequest />
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>


                
                </>
            )
        }
        else {
            return <></>    
        }
    }
}

export default CompanyPagesTab